module.exports = __webpack_public_path__ + "static/media/rna-based-treatments.f1d632ef.jpg";